import classes from "./Header.module.css";
import sponsor from "./../../../SMARTCITY/assets/images/sponsor.png";
import city from "./../../../SMARTCITY/assets/images/city.png";
import cityEn from "./../../../TEMPLATE/assets/images/smartiscity_logo.png";
import volosEL from "../../../SMARTCITY/assets/svg/volosLogo.svg";
// import volosEN from "../../../SMARTCITY/assets/svg/volosLogoEn.svg";
import { useHistory, useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import LanguageContext from "./../../hooks/language-context";
import cookies from "js-cookie";
import i18next from "i18next";
import styled from "styled-components";
import * as Icon from "../../components/Map/smartiscity/Icons";
import { useAuth } from "../../hooks/UserAuthProvider";
import BasicPopover from "../../components/BasicPopover";
import { handleLogin } from "../../components/Map/utils";
import ViewModal from "../../components/Map/container/ViewModal";
import { logoutUser } from "../../services/services";
import LogoutContent from "../../components/LogoutContent";
import { getI18n } from "react-i18next";

const Header = () => {
  const history = useHistory();
  const languageCtx = useContext(LanguageContext);
  const { search } = useLocation();
  const { language } = getI18n();
  const typeIdFromURL = new URLSearchParams(search).get("typeId");
  const currentLanguageCode = cookies.get("i18next") || "el";
  const { isAuthenticated, logout, tokens } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const page = window.location.href;

  const redirectHandler = () =>
    history.location.pathname !== "/" && history.push("/");

  const changeLanguage = (newLang) => {
    i18next.changeLanguage(newLang).catch((error) => console.warn(error));
    languageCtx.languageCodeHandler(newLang);
  };

  return (
    <header
      style={{
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        zIndex: "5",
      }}
    >
      <div
        style={{
          height: "40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "15px 6px",
          boxShadow: "0px 0px 12px 0px rgb(0 0 0 / 12%)",
          backgroundColor: "white",
          zIndex: "5",
        }}
      >
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            redirectHandler();
          }}
          aria-label="Volos Smart City — go to home"
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            cursor: "pointer",
            textDecoration: "none",
          }}
        >
          <img src={volosEL} alt="smartIsCity logo" width={74} />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span
              style={{
                color: "#313F98",
                fontSize: 18,
                fontWeight: "600",
                margin: "-4px 0",
                padding: 0,
              }}
            >
              ΔΗΜΟΣ ΒΟΛΟΥ
            </span>
            <span
              style={{ color: "#313F98", fontSize: 19, margin: 0, padding: 0 }}
            >
              Έξυπνη πόλη
            </span>
          </div>
        </a>
        {/* ============== */}
        {/* {(typeIdFromURL === "122" || page.includes("profile")) &&
          (!isAuthenticated ? (
            <NewRouteButton type="primary" onClick={() => handleLogin()}>
              <img src={Icon.login} alt="" aria-hidden="true" />
              Σύνδεση
            </NewRouteButton>
          ) : (
            <UserAvatar $isPageProfile={page.includes("profile")}>
              <BasicPopover
                buttonTitle="user-avatar"
                showPopover={showUserMenu}
                setShowPopover={setShowUserMenu}
                icon
                isPageProfile={page.includes("profile")}
              >
                <UserMenu>
                  <UserMenuItem
                    onClick={() => {
                      setShowUserMenu(false);
                      history.push("/profile");
                    }}
                  >
                    Προφίλ
                  </UserMenuItem>
                  <UserMenuItem
                    onClick={() => {
                      setShowUserMenu(false);
                      setShowLogoutModal(true);
                      // logout();
                    }}
                  >
                    Αποσύνδεση
                  </UserMenuItem>
                </UserMenu>
              </BasicPopover>
            </UserAvatar>
          ))} */}

        <LanguageContainer>
          <LanguageItem
            as="button"
            type="button"
            aria-pressed={language === "el"}
            aria-label="Switch to Greek"
            key="el"
            $isCurrentLanguage={language === "el"}
            onClick={() => {
              changeLanguage("el");
            }}
          >
            EL
          </LanguageItem>
          |
          <LanguageItem
            as="button"
            type="button"
            aria-pressed={language === "en"}
            aria-label="Switch to English"
            key="en"
            $isCurrentLanguage={language === "en"}
            onClick={() => {
              changeLanguage("en");
            }}
          >
            EN
          </LanguageItem>
        </LanguageContainer>
        {/* <div className={classes.sponsor_logo__container}>
        <img src={sponsor} alt="sponsor logo" className={classes.logo_normal} />
      </div> */}
        <ViewModal
          modalStatus={showLogoutModal}
          title="Επιβεβαίωση αποσυνδεσης"
          closeModal={() => {
            setShowLogoutModal(false);
          }}
        >
          <LogoutContent setShowLogoutModal={setShowLogoutModal} />
        </ViewModal>
      </div>
    </header>
  );
};

export default Header;

const NewRouteButton = styled.button`
  border-radius: 12px;
  background-color: #27aae1;
  width: fit-content;
  height: fit-content;
  padding: 10px 16px;
  color: #000;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  &:hover {
    background-color: #4bc7fa;
  }
  transition: all 0.6s ease;
`;

const UserMenu = styled.div`
  width: 140px;
  max-height: 300px;
  // padding: 20px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
`;

const UserMenuItem = styled.div`
  cursor: pointer;
  width: 100%;
  height: 20px;
  padding: 10px;
  &:hover {
    color: blue;
    background-color: rgba(0, 0, 0, 0.02);
  }
`;

const UserAvatar = styled.div`
  display: ${({ $isPageProfile }) => {
    return $isPageProfile ? "none" : "block";
  }} !important;

  @media only screen and (max-width: 808px) {
    display: block !important;
  }
`;

const LanguageContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  padding: 4px 8px;
`;

const LanguageItem = styled.button`
  font-weight: ${({ $isCurrentLanguage }) =>
    $isCurrentLanguage ? "600" : "500"};
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    border-bottom: 2px solid black;
    transition: all 0.3s ease-in-out;
    transform: translate(0, -10%);
  }
`;
